import { Breadcrumb, Flex, Space, Tabs, Button, ConfigProvider } from "antd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import MyTeamAllListTable from "./MyTeamAllListTable";
import MyTimesheetTeamCalendarPage from "../pages/MyTimesheetTeamCalendarPage";
import ApproveTeamTimesheetModal from "./ApproveTeamTimesheetModal";
import { useSelector } from "react-redux";


const MyTimesheet = ({
    useFilter = false,
    setUseFilter = () => { },
    useFilterDetail = false,
    setUseFilterDetail = () => { },
    myTimesheetAllListWithKey = [],
    onPageChange = () => { },
    isLoading = false,
    pagination = {},
    paginationDetails = {},
    rowSelection = () => { },
    hasSelected = false,
    selectedRowKeys,
    setSelectedRowKeys = () => { },
    onApproveTimesheetByEmployee = () => { },
    onView = () => { },
    isModalOpen = false,
    timesheetDetailsByEmp = [],
    selectedRecord = null,
    onTimesheetDetailsPageChange = () => { },
    setIsModalOpen = () => { },
    onApproveTimesheetByList = () => { },
    onRejectTimesheetByList = () => { },
    projectForApproverOptions = [],
    handleSearch = () => { },
    taskOptions = [],
    handleSearchDetailModal = () => { },
    onRejectedTimesheetByEmployee = () => { }
}) => {
    const { t } = useTranslation();
    const [selectedMenu, setSelectedMenu] = useState('all_list');
    const { roles } = useSelector((state) => state.company);

    const menuBreadcrumbMapping = {
        'all_list': t('Alllist.header'),
        'calender': t('team_timesheet.label.team_calendar'),
    }

    const handleTabChange = (key) => {
        setSelectedMenu(key);
    };

    return (
        <MainLayout>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb
                        items={[
                            { title: t("home.header"), href: "/" },
                            { title: t("timesheet.header"), href: "" },
                            { title: t("team_timesheet.header"), href: "" },
                            { title: menuBreadcrumbMapping[selectedMenu] || t("Alllist.header") },
                        ]}
                    />
                    <h2>{menuBreadcrumbMapping[selectedMenu] || t("Alllist.header")}</h2>
                    <span>
                        {t("my_team.label.detail_all_list")}
                    </span>
                </Flex>

                <ConfigProvider
                    theme={{
                        components: {
                            Tabs: {
                                itemHoverColor: "var(--tab-color)",
                                itemActiveColor: "var(--tab-color)"
                            },
                        },
                    }}
                >
                    <Tabs destroyInactiveTabPane={true} defaultActiveKey="all_list" onChange={handleTabChange}>
                        {roles.includes("ACCESS_TIMESHEET|MY_TEAM|ALL_LIST") && (
                            <Tabs.TabPane tab={t('Alllist.header')} key={"all_list"}>
                                <ApproveTeamTimesheetModal
                                    open={isModalOpen}
                                    timesheetDetailsByEmp={timesheetDetailsByEmp}
                                    selectedRecord={selectedRecord}
                                    onTimesheetDetailsPageChange={onTimesheetDetailsPageChange}
                                    isLoading={isLoading}
                                    pagination={paginationDetails}
                                    setIsModalOpen={setIsModalOpen}
                                    onApproveTimesheetByList={onApproveTimesheetByList}
                                    onRejectTimesheetByList={onRejectTimesheetByList}
                                    useFilterDetail={useFilterDetail}
                                    setUseFilterDetail={setUseFilterDetail}
                                    taskOptions={taskOptions}
                                    handleSearchDetailModal={handleSearchDetailModal}
                                />
                                <MyTeamAllListTable
                                    useFilter={useFilter}
                                    setUseFilter={setUseFilter}
                                    myTimesheetAllListWithKey={myTimesheetAllListWithKey}
                                    onPageChange={onPageChange}
                                    isLoading={isLoading}
                                    pagination={pagination}
                                    rowSelection={rowSelection}
                                    hasSelected={hasSelected}
                                    selectedRowKeys={selectedRowKeys}
                                    setSelectedRowKeys={setSelectedRowKeys}
                                    onApproveTimesheetByEmployee={onApproveTimesheetByEmployee}
                                    onView={onView}
                                    projectForApproverOptions={projectForApproverOptions}
                                    handleSearch={handleSearch}
                                    onRejectedTimesheetByEmployee={onRejectedTimesheetByEmployee}
                                />
                            </Tabs.TabPane>
                        )}

                        {roles.includes("ACCESS_TIMESHEET|MY_TEAM|TEAM_CALENDAR") && (
                            <Tabs.TabPane tab={t('team_timesheet.label.team_calendar')} key={"calender"}>
                                <MyTimesheetTeamCalendarPage />
                            </Tabs.TabPane>
                        )}

                    </Tabs>
                </ConfigProvider>

            </Space>
        </MainLayout>
    );
};

export default MyTimesheet;
